import { formatPhp } from "../lib/money";
import "./WorkspaceMetadata.css";

export function WorkspaceMetadata({ label, amount }: { label: string; amount?: number }) {
  const amountText = amount == null ? null : formatPhp(amount);
  return <div className="workspace-metadata text-xs text-mut">
    <span className="workspace-metadata-label truncate" title={label}>{label}</span>
    {amountText !== null && <><span aria-hidden="true">·</span>
      <span className="workspace-metadata-amount truncate font-semibold text-navy" title={amountText}>{amountText}</span></>}
  </div>;
}
